import React from "react";
import style from './skeleton.module.scss';

const Skeleton = (props) => {

    return (
        <div
            className={`${style[props.type]} ${style.loading}`}
            style={{ width: props.width, height: props.height }}
        >
        </div>
    )

}
export default Skeleton

//how to use
/*
type = "circle"           : required type of Skeleton : circle/rectangle
width = "25px"            : required width
height = "25px"           : required height
*/
